import moment from 'moment';
import _ from 'lodash';
import luhn from 'fast-luhn';

import template from './setAutoPayModal.html';
import './setAutoPayModal.scss';

class SetAutoPayModalController {
    /* @ngInject */constructor(dataContext, constants) {
        this.dataContext = dataContext;
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.constants = constants;
        this.isValid = false;
        this.availablePayments = [];
    }

    $onInit() {
        _.each(this.data.customerBillingInfo, (i, v) => {
            if (!this.isExpiratedCcExp(i)) {
                this.availablePayments.push(i);
            }
        });
    }

    close() {
        this.$dismiss();
    }

    modalDeleteCancel() {
        this.removeCheckState();
    }

    setAutopayMethod() {
        this.selectedCBI = this.selectedPayment;
        this.saveCBI();
        
        this.removeCheckState();
    }

    selectOneCheckbox(cbi) {
        this.selectedPayment = cbi;
        this.selectedPayment.IsDefaultPayment = true;
        this.selectedPayment.IsDefaultRmr = true;
        this.isValid = true;
    }

    saveCBI() {
        this.isLoading = true;
        if (this.selectedCBI.IsCredit) {
            this.selectedCBI.CCExp = this.selectedCBI.CcExpMonth + '/' + this.selectedCBI.CcExpYear.toString().substring(2, this.selectedCBI.CcExpYear.toString().length);
            this.selectedCBI.AccountNumber = this.selectedCBI.CardCcNumb;
        } else {
            this.selectedCBI.CheckAccountType = this.selectedCBI.CheckAccountType.substring(0, 1);
            this.selectedCBI.CheckType = this.selectedCBI.CheckType.substring(0, 1);
        }

        if (this.selectedCBI.CustomerBillingInfoID !== 0) {
            this.errorMsg = 'Edit Failed!';
            this.successMsg = 'Edit Successful!';

            if (this.selectedCBI.setToDefaultRmr) {
                this.errorMsg = 'Autopay Update Failed!';
                this.successMsg = 'Autopay Update Successful!';
                this.selectedCBI.IsDefaultRmr = true;
            }

            this.dataContext.customerBillingInfo.updateCustomerBillingInfo(this.selectedCBI)
                .then((result) => {
                    this.$close(result);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }

    removeCheckState() {
        _.each(this.availablePayments, (i, v) => {
            delete i.isChecked;
        });

        _.each(this.availableRmr, (i, v) => {
            delete i.isChecked;
        });
    }

    isExpiratedCcExp(cbi) {
        if (cbi.IsCredit) {
            let curDate = new Date();
            let cardInfoArray = cbi.CCExp.split('/');

            if (cardInfoArray.length == 2) {
                let cardDate = new Date(cardInfoArray[0] + '/01/20' + cardInfoArray[1]);
                cardDate.setMonth(cardDate.getMonth() + 1);

                return cardDate < curDate;
            } else {
                // safeguard against cbi ccexp split
                return false;
            }
            
        } else {
            return false;
        }
    }
}

export default {
    template: template,
    bindings: {
        config: '<',
        customerInfo: '<'
    },
    controller: SetAutoPayModalController
};